import React from "react";
import { Link } from "react-router-dom";
import classes from "./BreadCrumbComp.module.css";

export default function BreadCrumbComp({ currentPage, title, description }) {
  return (
    <section className={classes.breadcrumbWrapper}>
      <div className={classes.breadcrumbNav}>
        <Link to="/" className={classes.breadcrumbHome}>
          Home
        </Link>
        <span className={classes.breadcrumbSeparator}>›</span>
        <span className={classes.breadcrumbCurrent}>{currentPage}</span>
      </div>

      <h1 className={classes.breadcrumbTitle}>{title}</h1>

      {description && (
        <p className={classes.breadcrumbDescription}>{description}</p>
      )}
    </section>
  );
}
